module.exports = __webpack_public_path__ + "img/IMG_8963.76d33656.jpg";